export const StateService = {
  getOld: () => {
    return [
      { id: 1, value: "AL", label: "Alabama" },
      { id: 2, value: "AK", label: "Alaska" },
      { id: 3, value: "AZ", label: "Arizona" },
      { id: 4, value: "AR", label: "Arkansas" },
      { id: 5, value: "CA", label: "California" },
      { id: 7, value: "CO", label: "Colorado" },
      { id: 6, value: "CT", label: "Connecticut" },
      { id: 8, value: "DE", label: "Delaware" },
      { id: 9, value: "FL", label: "Florida" },
      { id: 10, value: "GA", label: "Georgia" },
      { id: 11, value: "HI", label: "Hawaii" },
      { id: 12, value: "ID", label: "Idaho" },
      { id: 13, value: "IL", label: "Illinois" },
      { id: 14, value: "IN", label: "Indiana" },
      { id: 15, value: "IA", label: "Iowa" },
      { id: 16, value: "KS", label: "Kansas" },
      { id: 17, value: "KY", label: "Kentucky" },
      { id: 18, value: "LA", label: "Louisiana" },
      { id: 19, value: "ME", label: "Maine" },
      { id: 20, value: "MD", label: "Maryland" },
      { id: 21, value: "MA", label: "Massachusetts" },
      { id: 22, value: "MI", label: "Michigan" },
      { id: 23, value: "MN", label: "Minnesota" },
      { id: 24, value: "MS", label: "Mississippi" },
      { id: 24, value: "MO", label: "Missouri" },
      { id: 26, value: "MT", label: "Montana" },
      { id: 27, value: "NE", label: "Nebraska" },
      { id: 28, value: "NV", label: "Nevada" },
      { id: 29, value: "NH", label: "New Hampshire" },
      { id: 30, value: "NJ", label: "New Jersey" },
      { id: 31, value: "NM", label: "New Mexico" },
      { id: 32, value: "NY", label: "New York" },
      { id: 33, value: "NC", label: "North Carolina" },
      { id: 34, value: "ND", label: "North Dakota" },
      { id: 35, value: "OH", label: "Ohio" },
      { id: 36, value: "OK", label: "Oklahoma" },
      { id: 37, value: "OR", label: "Oregon" },
      { id: 38, value: "PA", label: "Pennsylvania" },
      { id: 39, value: "RI", label: "Rhode Island" },
      { id: 40, value: "SC", label: "South Carolina" },
      { id: 41, value: "SD", label: "South Dakota" },
      { id: 42, value: "TN", label: "Tennessee" },
      { id: 43, value: "TX", label: "Texas" },
      { id: 44, value: "UT", label: "Utah" },
      { id: 45, value: "VT", label: "Vermont" },
      { id: 46, value: "VA", label: "Virginia" },
      { id: 47, value: "WA", label: "Washington" },
      { id: 48, value: "WV", label: "West Virginia" },
      { id: 49, value: "WI", label: "Wisconsin" },
      { id: 50, value: "WY", label: "Wyoming" },
      { id: 51, value: "DC", label: "Washington, D.C." },
    ];
  },
  getOperatingProvincesList: () => {
    return [
      { id: 1, value: 1, label: "Alabama" },
      { id: 2, value: 2, label: "Alaska" },
      { id: 3, value: 3, label: "Arizona" },
      { id: 4, value: 4, label: "Arkansas" },
      { id: 5, value: 5, label: "California" },
      { id: 7, value: 6, label: "Colorado" },
      { id: 6, value: 7, label: "Connecticut" },
      { id: 8, value: 8, label: "Delaware" },
      { id: 9, value: 9, label: "Florida" },
      { id: 10, value: 10, label: "Georgia" },
      { id: 11, value: 11, label: "Hawaii" },
      { id: 12, value: 12, label: "Idaho" },
      { id: 13, value: 13, label: "Illinois" },
      { id: 14, value: 14, label: "Indiana" },
      { id: 15, value: 15, label: "Iowa" },
      { id: 16, value: 16, label: "Kansas" },
      { id: 17, value: 17, label: "Kentucky" },
      { id: 18, value: 18, label: "Louisiana" },
      { id: 19, value: 19, label: "Maine" },
      { id: 20, value: 20, label: "Maryland" },
      { id: 21, value: 21, label: "Massachusetts" },
      { id: 22, value: 22, label: "Michigan" },
      { id: 23, value: 23, label: "Minnesota" },
      { id: 24, value: 24, label: "Mississippi" },
      { id: 25, value: 25, label: "Missouri" },
      { id: 26, value: 26, label: "Montana" },
      { id: 27, value: 27, label: "Nebraska" },
      { id: 28, value: 28, label: "Nevada" },
      { id: 29, value: 29, label: "New Hampshire" },
      { id: 30, value: 30, label: "New Jersey" },
      { id: 31, value: 31, label: "New Mexico" },
      { id: 32, value: 32, label: "New York" },
      { id: 33, value: 33, label: "North Carolina" },
      { id: 34, value: 34, label: "North Dakota" },
      { id: 35, value: 35, label: "Ohio" },
      { id: 36, value: 36, label: "Oklahoma" },
      { id: 37, value: 37, label: "Oregon" },
      { id: 38, value: 38, label: "Pennsylvania" },
      { id: 39, value: 39, label: "Rhode Island" },
      { id: 40, value: 40, label: "South Carolina" },
      { id: 41, value: 41, label: "South Dakota" },
      { id: 42, value: 42, label: "Tennessee" },
      { id: 43, value: 43, label: "Texas" },
      { id: 44, value: 44, label: "Utah" },
      { id: 45, value: 45, label: "Vermont" },
      { id: 46, value: 46, label: "Virginia" },
      { id: 47, value: 47, label: "Washington" },
      { id: 48, value: 48, label: "West Virginia" },
      { id: 49, value: 49, label: "Wisconsin" },
      { id: 50, value: 50, label: "Wyoming" },
      { id: 51, value: 51, label: "Washington, D.C." },
    ];
  },
  get: () => {
    return [
      // according to situation we have to send in responce this value for UPDATE but for get by id to show province only string show the value
      {id:"1", label: "Alabama", value: '{id:1, name: "Alabama",shortCode:"AL"}' },
      {id:"2", label: "Alaska", value: '{id:2, name: "Alaska",shortCode:"AK"}',},
      {id:"3", label: "Arizona", value: '{id:3, name: "Arizona",shortCode:"AZ"}' },
      {id:"4", label: "Arkansas", value: '{id:4, name: "Arkansas",shortCode:"AR"}',},
      {id:"5", label: "California", value: '{id:5, name: "California",shortCode:"CA"}',},
      {id:"7", label: "Colorado", value: '{id:7, name: "Colorado",shortCode:"CO"}',},
      {id:"6", label: "Connecticut", value: '{id:6, name: "Connecticut",shortCode:"CT"}',},
      {id:"8", label: "Delaware", value: '{id:8, name: "Delaware",shortCode:"DE"}' },
      {id:"9", label: "Florida", value: '{id:9, name: "Florida",shortCode:"FL"}' },
      {id:"10", label: "Georgia", value: '{id:10, name: "Georgia",shortCode:"GA"}'},
      {id:"11", label: "Hawaii", value: '{id:11, name: "Hawaii",shortCode:"HI"}' },
      {id:"12", label: "Idaho", value: '{id:12, name: "Idaho",shortCode:"ID"}'},
      {id:"13", label: "Illinois", value: '{id:13, name: "Illinois",shortCode:"IL"}' },
      {id:"14", label: "Indiana", value: '{id:14, name: "Indiana",shortCode:"IN"}' },
      {id:"15", label: "Iowa", value: '{id:15, name: "Iowa",shortCode:"IA"}',},
      {id:"16", label: "Kansas", value: '{id:16, name: "Kansas",shortCode:"KS"}' },
      {id:"17", label: "Kentucky", value: '{id:17, name: "Kentucky",shortCode:"KY"}',},
      {id:"18", label: "Louisiana", value: '{id:18, name: "Louisiana",shortCode:"LA"}',},
      {id:"19", label: "Maine", value: '{id:19, name: "Maine",shortCode:"ME"}',},
      {id:"20", label: "Maryland", value: '{id:20, name: "Maryland",shortCode:"MD"}',},
      {id:"21", label: "Massachusetts", value: '{id:21, name: "Massachusetts",shortCode:"MA"}' },
      {id:"22", label: "Michigan", value: '{id:22, name: "Michigan",shortCode:"MI"}' },
      {id:"23", label: "Minnesota", value: '{id:23, name: "Minnesota",shortCode:"MN"}'},
      {id:"24", label: "Mississippi", value: '{id:24, name: "Mississippi",shortCode:"MS"}' },
      {id:"25", label: "Missouri", value: '{id:25, name: "Missouri",shortCode:"MO"}'},
      {id:"26", label: "Montana", value: '{id:26, name: "Montana",shortCode:"MT"}' },
      {id:"27", label: "Nebraska", value: '{id:27, name: "Nebraska",shortCode:"NE"}' },
      {id:"28", label: "Nevada", value: '{id:28, name: "Nevada",shortCode:"NV"}',},
      {id:"29", label: "New Hampshire", value: '{id:29, name: "New Hampshire",shortCode:"NH"}' },
      {id:"30", label: "New Jersey", value: '{id:30, name: "New Jersey",shortCode:"NJ"}',},
      {id:"31", label: "New Mexico", value: '{id:31, name: "New Mexico",shortCode:"NM"}',},
      {id:"32", label: "New York", value: '{id:32, name: "New York",shortCode:"NY"}',},
      {id:"33", label: "North Carolina", value: '{id:33, name: "North Carolina",shortCode:"NC"}',},
      {id:"34", label: "North Dakota", value: '{id:34, name: "North Dakota",shortCode:"ND"}' },
      {id:"35", label: "Ohio", value: '{id:35, name: "Ohio",shortCode:"OH"}' },
      {id:"36", label: "Oklahoma", value: '{id:36, name: "Oklahoma",shortCode:"OK"}'},
      {id:"37", label: "Oregon", value: '{id:37, name: "Oregon",shortCode:"OR"}' },
      {id:"38", label: "Pennsylvania", value: '{id:38, name: "Pennsylvania",shortCode:"PA"}'},
      {id:"39", label: "Rhode Island", value: '{id:39, name: "Rhode Island",shortCode:"RI"}' },
      {id:"40", label: "South Carolina", value: '{id:40, name: "South Carolina",shortCode:"SC"}' },
      {id:"41", label: "South Dakota", value: '{id:41, name: "South Dakota",shortCode:"SD"}',},
      {id:"42", label: "Tennessee", value: '{id:42, name: "Tennessee",shortCode:"TN"}' },
      {id:"43", label: "Texas", value: '{id:43, name: "Texas",shortCode:"TX"}',},
      {id:"44", label: "Utah", value: '{id:44, name: "Utah",shortCode:"UT"}',},
      {id:"45", label: "Vermont", value: '{id:45, name: "Vermont",shortCode:"VT"}',},
      {id:"46", label: "Virginia", value: '{id:46, name: "Virginia",shortCode:"VA"}',},
      {id:"47", label: "Washington", value: '{id:47, name: "Washington",shortCode:"WA"}' },
      {id:"48", label: "West Virginia", value: '{id:48, name: "West Virginia",shortCode:"WV"}' },
      {id:"49", label: "Wisconsin", value: '{id:49, name: "Wisconsin",shortCode:"WI"}'},
      {id:"50", label: "Wyoming", value: '{id:50, name: "Wyoming",shortCode:"WY"}' },
      {id:"51", label: "Washington, D.C.", value: '{id:51, name: "Washington, D.C.",shortCode:"DC"}' },
    ];
  },
  getPOE: () => {
    return [
      // according to situation we have to send in responce this value for UPDATE
      { label: "Alabama", value: '{id:1, name: "Alabama",shortCode:"AL"}' },
      {
        label: "Alaska",
        value: { id: 2, name: "Alaska", shortCode: "AK" },
      },
      {
        label: "Arizona",
        value: { id: 3, name: "Arizona", shortCode: "AZ" },
      },
      {
        label: "Arkansas",
        value: { id: 4, name: "Arkansas", shortCode: "AR" },
      },
      {
        label: "California",
        value: { id: 5, name: "California", shortCode: "CA" },
      },
      {
        label: "Colorado",
        value: { id: 7, name: "Colorado", shortCode: "CO" },
      },
      {
        label: "Connecticut",
        value: '{id:6, name: "Connecticut",shortCode:"CT"}',
      },
      { label: "Delaware", value: { id: 8, name: "Delaware", shortCode: "DE" } },
      { label: "Florida", value: { id: 9, name: "Florida", shortCode: "FL" } },
      {
        label: "Georgia",
        value: { id: 10, name: "Georgia", shortCode: "GA" },
      },
      { label: "Hawaii", value: { id: 11, name: "Hawaii", shortCode: "HI" } },
      {
        label: "Idaho",
        value: { id: 12, name: "Idaho", shortCode: "ID" },
      },
      { label: "Illinois", value: { id: 13, name: "Illinois", shortCode: "IL" } },
      { label: "Indiana", value: '{id:1, name: "Indiana",shortCode:"IN"}' },
      {
        label: "Iowa",
        value: { id: 2, name: "Iowa", shortCode: "IA" },
      },
      {
        label: "Kansas",
        value: { id: 3, name: "Kansas", shortCode: "KS" },
      },
      {
        label: "Kentucky",
        value: { id: 4, name: "Kentucky", shortCode: "KY" },
      },
      {
        label: "Louisiana",
        value: { id: 5, name: "Louisiana", shortCode: "LA" },
      },
      {
        label: "Maine",
        value: { id: 7, name: "Maine", shortCode: "ME" },
      },
      {
        label: "Maryland",
        value: '{id:6, name: "Maryland",shortCode:"MD"}',
      },
      { label: "Massachusetts", value: { id: 8, name: "Massachusetts", shortCode: "MA" } },
      { label: "Michigan", value: { id: 9, name: "Michigan", shortCode: "MI" } },
      {
        label: "Minnesota",
        value: { id: 10, name: "Minnesota", shortCode: "MN" },
      },
      { label: "Mississippi", value: { id: 11, name: "Mississippi", shortCode: "MS" } },
      {
        label: "Missouri",
        value: { id: 12, name: "Missouri", shortCode: "MO" },
      },
      { label: "Montana", value: { id: 13, name: "Montana", shortCode: "MT" } },
      { label: "Nebraska", value: '{id:1, name: "Nebraska",shortCode:"NE"}' },
      {
        label: "Nevada",
        value: { id: 2, name: "Nevada", shortCode: "NV" },
      },
      {
        label: "New Hampshire",
        value: { id: 3, name: "New Hampshire", shortCode: "NH" },
      },
      {
        label: "New Jersey",
        value: { id: 4, name: "New Jersey", shortCode: "NJ" },
      },
      {
        label: "New Mexico",
        value: { id: 5, name: "New Mexico", shortCode: "NM" },
      },
      {
        label: "New York",
        value: { id: 7, name: "New York", shortCode: "NY" },
      },
      {
        label: "North Carolina",
        value: '{id:6, name: "North Carolina",shortCode:"NC"}',
      },
      { label: "North Dakota", value: { id: 8, name: "North Dakota", shortCode: "ND" } },
      { label: "Ohio", value: { id: 9, name: "Ohio", shortCode: "OH" } },
      {
        label: "Oklahoma",
        value: { id: 10, name: "Oklahoma", shortCode: "OK" },
      },
      { label: "Oregon", value: { id: 11, name: "Oregon", shortCode: "OR" } },
      {
        label: "Pennsylvania",
        value: { id: 12, name: "Pennsylvania", shortCode: "PA" },
      },
      { label: "Rhode Island", value: { id: 13, name: "Rhode Island", shortCode: "RI" } },
      { label: "South Carolina", value: '{id:1, name: "South Carolina",shortCode:"SC"}' },
      {
        label: "South Dakota",
        value: { id: 2, name: "South Dakota", shortCode: "SD" },
      },
      {
        label: "Tennessee",
        value: { id: 3, name: "Tennessee", shortCode: "TN" },
      },
      {
        label: "Texas",
        value: { id: 4, name: "Texas", shortCode: "TX" },
      },
      {
        label: "Utah",
        value: { id: 5, name: "Utah", shortCode: "UT" },
      },
      {
        label: "Vermont",
        value: { id: 7, name: "Vermont", shortCode: "VT" },
      },
      {
        label: "Virginia",
        value: '{id:6, name: "Virginia",shortCode:"VA"}',
      },
      { label: "Washington", value: { id: 8, name: "Washington", shortCode: "WA" } },
      { label: "West Virginia", value: { id: 9, name: "West Virginia", shortCode: "WV" } },
      {
        label: "Wisconsin",
        value: { id: 10, name: "Wisconsin", shortCode: "WI" },
      },
      { label: "Wyoming", value: { id: 11, name: "Wyoming", shortCode: "WY" } },
    ];
  },
};
export let PROVINCE_OF_EMPLOYMENT = ''
export const getPROVINCE_OF_EMPLOYMENT = (val:any) => {
  // alert(val)
    if(val === 1){
      PROVINCE_OF_EMPLOYMENT = '{id:1, name: "Alabama",shortCode:"AL"}'
    }
    else if (val === 2){
      PROVINCE_OF_EMPLOYMENT = '{id:2, name: "Alaska",shortCode:"AK"}'
    }
    else if (val === 3){
      PROVINCE_OF_EMPLOYMENT = '{id:3, name: "Arizona",shortCode:"AZ"}'
    }
    else if (val === 4){
      PROVINCE_OF_EMPLOYMENT = '{id:4, name: "Arkansas",shortCode:"AR"}'
    }
    else if (val === 5){
      PROVINCE_OF_EMPLOYMENT = '{id:5, name: "California",shortCode:"CA"}'
    }
    else if (val === 7){
      PROVINCE_OF_EMPLOYMENT = '{id:7, name: "Colorado",shortCode:"CO"}'
    }
    else if (val === 6){
      PROVINCE_OF_EMPLOYMENT = '{id:6, name: "Connecticut",shortCode:"CT"}'
    }
    else if (val === 8){
      PROVINCE_OF_EMPLOYMENT = '{id:8, name: "Delaware",shortCode:"DE"}'
    }
    else if (val === 9){
      PROVINCE_OF_EMPLOYMENT = '{id:9, name: "Florida",shortCode:"FL"}'
    }
    else if (val === 10){
      PROVINCE_OF_EMPLOYMENT = '{id:10, name: "Georgia",shortCode:"GA"}'
    }
    else if (val === 11){
      PROVINCE_OF_EMPLOYMENT = '{id:11, name: "Hawaii",shortCode:"HI"}'
    }
    else if (val === 12){
      PROVINCE_OF_EMPLOYMENT = '{id:12, name: "Idaho",shortCode:"ID"}'
    }
    else if (val === 13){
      PROVINCE_OF_EMPLOYMENT = '{id:13, name: "Illinois",shortCode:"IL"}'
    }
    else if(val === 14){
      PROVINCE_OF_EMPLOYMENT = '{id:14, name: "Indiana",shortCode:"IN"}'
    }
    else if (val === 15){
      PROVINCE_OF_EMPLOYMENT = '{id:15, name: "Iowa",shortCode:"IA"}'
    }
    else if (val === 16){
      PROVINCE_OF_EMPLOYMENT = '{id:16, name: "Kansas",shortCode:"KS"}'
    }
    else if (val === 17){
      PROVINCE_OF_EMPLOYMENT = '{id:17, name: "Kentucky",shortCode:"KY"}'
    }
    else if (val === 18){
      PROVINCE_OF_EMPLOYMENT = '{id:18, name: "Louisiana",shortCode:"LA"}'
    }
    else if (val === 19){
      PROVINCE_OF_EMPLOYMENT = '{id:19, name: "Maine",shortCode:"ME"}'
    }
    else if (val === 20){
      PROVINCE_OF_EMPLOYMENT = '{id:20, name: "Maryland",shortCode:"MD"}'
    }
    else if (val === 21){
      PROVINCE_OF_EMPLOYMENT = '{id:21, name: "Massachusetts",shortCode:"MA"}'
    }
    else if (val === 22){
      PROVINCE_OF_EMPLOYMENT = '{id:22, name: "Michigan",shortCode:"MI"}'
    }
    else if (val === 23){
      PROVINCE_OF_EMPLOYMENT = '{id:23, name: "Minnesota",shortCode:"MN"}'
    }
    else if (val === 24){
      PROVINCE_OF_EMPLOYMENT = '{id:24, name: "Mississippi",shortCode:"MS"}'
    }
    else if (val === 25){
      PROVINCE_OF_EMPLOYMENT = '{id:25, name: "Missouri",shortCode:"MO"}'
    }
    else if (val === 26){
      PROVINCE_OF_EMPLOYMENT = '{id:26, name: "Montana",shortCode:"MT"}'
    } else if(val === 27){
      PROVINCE_OF_EMPLOYMENT = '{id:27, name: "Nebraska",shortCode:"NE"}'
    }
    else if (val === 28){
      PROVINCE_OF_EMPLOYMENT = '{id:28, name: "Nevada",shortCode:"NV"}'
    }
    else if (val === 29){
      PROVINCE_OF_EMPLOYMENT = '{id:29, name: "New Hampshire",shortCode:"NH"}'
    }
    else if (val === 30){
      PROVINCE_OF_EMPLOYMENT = '{id:30, name: "New Jersey",shortCode:"NJ"}'
    }
    else if (val === 31){
      PROVINCE_OF_EMPLOYMENT = '{id:31, name: "New Mexico",shortCode:"NM"}'
    }
    else if (val === 32){
      PROVINCE_OF_EMPLOYMENT = '{id:32, name: "New York",shortCode:"NY"}'
    }
    else if (val === 33){
      PROVINCE_OF_EMPLOYMENT = '{id:33, name: "North Carolina",shortCode:"NC"}'
    }
    else if (val === 34){
      PROVINCE_OF_EMPLOYMENT = '{id:34, name: "North Dakota",shortCode:"ND"}'
    }
    else if (val === 35){
      PROVINCE_OF_EMPLOYMENT = '{id:35, name: "Ohio",shortCode:"OH"}'
    }
    else if (val === 36){
      PROVINCE_OF_EMPLOYMENT = '{id:36, name: "Oklahoma",shortCode:"OK"}'
    }
    else if (val === 37){
      PROVINCE_OF_EMPLOYMENT = '{id:37, name: "Oregon",shortCode:"OR"}'
    }
    else if (val === 38){
      PROVINCE_OF_EMPLOYMENT = '{id:38, name: "Pennsylvania",shortCode:"PA"}'
    }
    else if (val === 39){
      PROVINCE_OF_EMPLOYMENT = '{id:39, name: "Rhode Island",shortCode:"RI"}'
    } else if(val === 40){
      PROVINCE_OF_EMPLOYMENT = '{id:40, name: "South Carolina",shortCode:"SC"}'
    }
    else if (val === 41){
      PROVINCE_OF_EMPLOYMENT = '{id:41, name: "South Dakota",shortCode:"SD"}'
    }
    else if (val === 42){
      PROVINCE_OF_EMPLOYMENT = '{id:42, name: "Tennessee",shortCode:"TN"}'
    }
    else if (val === 43){
      PROVINCE_OF_EMPLOYMENT = '{id:43, name: "Texas",shortCode:"TX"}'
    }
    else if (val === 44){
      PROVINCE_OF_EMPLOYMENT = '{id:44, name: "Utah",shortCode:"UT"}'
    }
    else if (val === 45){
      PROVINCE_OF_EMPLOYMENT = '{id:45, name: "Vermont",shortCode:"VT"}'
    }
    else if (val === 46){
      PROVINCE_OF_EMPLOYMENT = '{id:46, name: "Virginia",shortCode:"VA"}'
    }
    else if (val === 47){
      PROVINCE_OF_EMPLOYMENT = '{id:47, name: "Washington",shortCode:"WA"}'
    }
    else if (val === 48){
      PROVINCE_OF_EMPLOYMENT = '{id:48, name: "West Virginia",shortCode:"WV"}'
    }
    else if (val === 49){
      PROVINCE_OF_EMPLOYMENT = '{id:49, name: "Wisconsin",shortCode:"WI"}'
    }
    else if (val === 50){
      PROVINCE_OF_EMPLOYMENT = '{id:50, name: "Wyoming",shortCode:"WY"}'
    }
    else if (val === 51){
      PROVINCE_OF_EMPLOYMENT = '{id:51, name: "Washington, D.C.",shortCode:"DC"}'
    }
  }

export const getProvinceByShortCode = (val:any) => {
    if(val === "AL"){
      return { id: 1, value: "AL", label: "Alabama" }
    }
    else if (val === "AK"){
      return { id: 2, value: "AK", label: "Alaska" }
    }
    else if (val === "AZ"){
      return { id: 3, value: "AZ", label: "Arizona" }
    }
    else if (val === "AR"){
      return { id: 4, value: "AR", label: "Arkansas" }
    }
    else if (val === "CA"){
      return { id: 5, value: "CA", label: "California" }
    }
    else if (val === "CO"){
      return { id: 7, value: "CO", label: "Colorado" }
    }
    else if (val === "CT"){
      return { id: 6, value: "CT", label: "Connecticut" }
    }
    else if (val === "DE"){
      return { id: 8, value: "DE", label: "Delaware" }
    }
    else if (val === "FL"){
      return { id: 9, value: "FL", label: "Florida" }
    }
    else if (val === "GA"){
      return { id: 10, value: "GA", label: "Georgia" }
    }
    else if (val === "HI"){
      return { id: 11, value: "HI", label: "Hawaii" }
    }
    else if (val === "ID"){
      return { id: 12, value: "ID", label: "Idaho" }
    }
    else if (val === "IL"){
      return { id: 13, value: "IL", label: "Illinois" }
    }
    else if(val === "IN"){
      return { id: 14, value: "IN", label: "Indiana" }
    }
    else if (val === "IA"){
      return { id: 15, value: "IA", label: "Iowa" }
    }
    else if (val === "KS"){
      return { id: 16, value: "KS", label: "Kansas" }
    }
    else if (val === "KY"){
      return { id: 17, value: "KY", label: "Kentucky" }
    }
    else if (val === "LA"){
      return { id: 18, value: "LA", label: "Louisiana" }
    }
    else if (val === "ME"){
      return { id: 19, value: "ME", label: "Maine" }
    }
    else if (val === "MD"){
      return { id: 20, value: "MD", label: "Maryland" }
    }
    else if (val === "MA"){
      return { id: 21, value: "MA", label: "Massachusetts" }
    }
    else if (val === "MI"){
      return { id: 22, value: "MI", label: "Michigan" }
    }
    else if (val === "MN"){
      return { id: 23, value: "MN", label: "Minnesota" }
    }
    else if (val === "MS"){
      return { id: 24, value: "MS", label: "Mississippi" }
    }
    else if (val === "MO"){
      return { id: 25, value: "MO", label: "Missouri" }
    }
    else if (val === "MT"){
      return { id: 26, value: "MT", label: "Montana" }
    } else if(val === "NE"){
      return { id: 27, value: "NE", label: "Nebraska" }
    }
    else if (val === "NV"){
      return { id: 28, value: "NV", label: "Nevada" }
    }
    else if (val === "NH"){
      return { id: 29, value: "NH", label: "New Hampshire" }
    }
    else if (val === "NJ"){
      return { id: 30, value: "NJ", label: "New Jersey" }
    }
    else if (val === "NM"){
      return { id: 31, value: "NM", label: "New Mexico" }
    }
    else if (val === "NY"){
      return { id: 32, value: "NY", label: "New York" }
    }
    else if (val === "NC"){
      return { id: 33, value: "NC", label: "North Carolina" }
    }
    else if (val === "ND"){
      return { id: 34, value: "ND", label: "North Dakota" }
    }
    else if (val === "OH"){
      return { id: 35, value: "OH", label: "Ohio" }
    }
    else if (val === "OK"){
      return { id: 36, value: "OK", label: "Oklahoma" }
    }
    else if (val === "OR"){
      return { id: 37, value: "OR", label: "Oregon" }
    }
    else if (val === "PA"){
      return { id: 38, value: "PA", label: "Pennsylvania" }
    }
    else if (val === "RI"){
      return { id: 39, value: "RI", label: "Rhode Island" }
    } else if(val === "SC"){
      return { id: 40, value: "SC", label: "South Carolina" }
    }
    else if (val === "SD"){
      return { id: 41, value: "SD", label: "South Dakota" }
    }
    else if (val === "TN"){
      return { id: 42, value: "TN", label: "Tennessee" }
    }
    else if (val === "TX"){
      return { id: 43, value: "TX", label: "Texas" }
    }
    else if (val === "UT"){
      return { id: 44, value: "UT", label: "Utah" }
    }
    else if (val === "VT"){
      return { id: 45, value: "VT", label: "Vermont" }
    }
    else if (val === "VA"){
      return { id: 46, value: "VA", label: "Virginia" }
    }
    else if (val === "WA"){
      return { id: 47, value: "WA", label: "Washington" }
    }
    else if (val === "WV"){
      return { id: 48, value: "WV", label: "West Virginia" }
    }
    else if (val === "WI"){
      return { id: 49, value: "WI", label: "Wisconsin" }
    }
    else if (val === "WY"){
      return { id: 50, value: "WY", label: "Wyoming" }
    }
    else if (val === "WY"){
      return { id: 51, value: "DC", label: "Washington, D.C." }
    }
  }